import React from 'react'
import { DateRangePicker } from 'react-date-range';

const CustomDateRangePicker = ({onRangeSelect}) => {
  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }
  return (
    <div className="fixed z-40 inset-0 overflow-y-auto">
    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div className="fixed inset-0 transition-opacity">
        <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
      </div>
      <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
      <div className="inline-block p-5 text-center text-gray-600 align-bottom rounded-lg bg-white overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <DateRangePicker
          onPreviewChange={[{
            startDate: new Date() - 60,
            endDate: new Date(),
            key: 'selection',
          }]}
          maxDate={new Date()}
          ranges={[selectionRange]}
          onChange={onRangeSelect}
        />
      </div>
    </div>
  </div>
  )
}

export default CustomDateRangePicker